<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	content: '',
}
const schema = defineSchema({
	content: $.richtext('Content', { basic: true }),
})
export const StoreSection = defineBlock({ thumbnail: '/block-thumbs/StoreSection.svg', category: 'Content', order: 390, name: 'StoreSection', label: 'Store Section', icon: 'view_agenda', schema, defaults })
</script>
<script setup lang="ts">


import BlockRichText from '@/components/blocks/BlockRichText.vue'

// Kept for CMS backward-compatibility. Delegates to the generic `BlockRichText`
// in its `store` variant (identical look to the original Store Section).



const props = defineProps<{
	content?: string
}>()
</script>

<template>
	<BlockRichText v-bind="{ content: props.content, variant: 'store' }" />
</template>
